import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { listWineAppellations } from 'redux/productFilters/actions';

class WineAppellationFilter extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    const queryObj = queryString.parse(location.search);
    this.state = {
      wineAppellation: queryObj.wineAppellation
    };
  }

  componentDidMount() {
    this.listWineAppellations();
  }

  componentDidUpdate(prevProps) {
    const { props } = this;
    if (prevProps.match.params.slug !== props.match.params.slug) {
      this.listWineAppellations();
    }
  }

  listWineAppellations = () => {
    const { props } = this;
    const { slug } = props.match.params;
    props.listWineAppellations(slug);
  };

  handleChange = (e) => {
    const wineAppellation = e.target.value;
    this.setState({ wineAppellation });
    this.handleQueryChange(wineAppellation);
  };

  handleQueryChange = (wineAppellation) => {
    const { location, history } = this.props;
    const parsed = queryString.parse(location.search);
    if (wineAppellation === '') {
      delete parsed.wineAppellation;
    } else {
      parsed.wineAppellation = wineAppellation;
    }
    delete parsed.page;
    const stringified = queryString.stringify(parsed);
    let url = location.pathname;
    if (stringified.length > 0) {
      url += `?${stringified}`;
    }
    history.push(url);
  };

  render() {
    const { wineAppellations } = this.props;
    const { wineAppellation } = this.state;
    if (wineAppellations.length === 0) {
      return null;
    }
    return (
      <>
        <div className="c7-selectbox">
          <label htmlFor="wineAppellation">
            Appellation:
            <span className="c7-selectboxWrap">
              <select
                id="wineAppellation"
                name="wineAppellation"
                value={wineAppellation}
                onChange={this.handleChange}
              >
                <option value="" />
                {wineAppellations.map((wt) => (
                  <option value={wt.wineAppellation} key={wt.wineAppellation}>
                    {wt.wineAppellation}
                  </option>
                ))}
              </select>
            </span>
          </label>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  wineAppellations: state.productFilter.wineAppellations
});

export default withRouter(
  connect(mapStateToProps, { listWineAppellations })(WineAppellationFilter)
);
